'use client';

import { Users } from 'lucide-react';

interface ContactManagementCompleteModalProps {
  onFinish: () => void;
}

export function ContactManagementCompleteModal({ onFinish }: ContactManagementCompleteModalProps) {
  return (
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Contact management tour complete"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Modal card */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full mx-4 p-8">
        {/* Icon */}
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent-blue/[0.08]">
          <Users className="h-8 w-8 text-accent-blue" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">
          Contacts at Your Fingertips
        </h2>

        {/* Content */}
        <div className="text-left space-y-4 mb-8">
          <p className="text-base leading-relaxed text-gray-500">
            You now know how to manage your entire client directory in Voley. From
            searching and filtering to tags, notes, and conversation management &mdash;{' '}
            <strong className="text-gray-700">everything is organized in one place</strong>.
          </p>
          <div className="bg-gray-50 rounded-lg p-4 space-y-2">
            <p className="text-sm text-gray-600">
              <strong className="text-gray-900">Pro tip:</strong> Use tags to categorize
              contacts by line of business or renewal month. Combined with the filter on
              the contacts page, you can instantly find the right group of clients for
              bulk messages or follow-ups.
            </p>
          </div>
          <p className="text-sm leading-relaxed text-gray-500">
            When your AMS is connected, contact details stay in sync automatically. Any
            updates in your AMS are reflected in Voley in real time &mdash; no manual
            work required.
          </p>
        </div>

        {/* Finish button */}
        <div className="flex justify-center">
          <button
            onClick={onFinish}
            aria-label="Finish tour"
            className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full text-base font-semibold text-white bg-accent-blue hover:brightness-110 transition-all shadow-md"
          >
            Finish Tour
          </button>
        </div>
      </div>
    </div>
  );
}
